import { ReportType } from '@utils-global';
import {
  ReportLoading,
  ReportResult,
  SpamReportResult,
  PhishingInteractedResult,
} from '@components';
import { useReport } from './hooks';
import { Report } from './components';
import { useReportMailFlow } from '../../hooks';

export const ReportPage = () => {
  const {
    mailId,
    actionsTaken,
    mailboxEmail,
    isOnPremises,
    originalUserEmail,
    isSharedMailbox,
    setActionsTaken,
    keepEmail,
    setKeepEmail,
  } = useReport();

  const { isLoading, report, screen, handleReport, resetReport } = useReportMailFlow({
    mailId,
    mailboxEmail,
    isSharedMailbox,
    originalUserEmail,
    actionsTaken,
    isOnPremises,
    reportType: ReportType.PHISHING,
    keepEmail,
  });

  if (isLoading) return <ReportLoading />;
  if (report) {
    if (screen === 'interacted') return <PhishingInteractedResult />;
    if (screen === 'verdict')
      return <SpamReportResult title={report.Title} description={report.Description} />;
    return <ReportResult report={report} onBack={resetReport} />;
  }
  return (
    <Report
      actionsTaken={actionsTaken}
      setActionsTaken={setActionsTaken}
      handleReportMail={handleReport}
      keepEmail={keepEmail}
      setKeepEmail={setKeepEmail}
    />
  );
};
